import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'propertyNames'
})

export class PropertyNamesPipe implements PipeTransform {
    transform(data: Object) {
        return (<any>Object).getOwnPropertyNames(data)
    }
}
